import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=fc0902a0&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=fc0902a0&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=fc0902a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0902a0",
  null
  
)

export default component.exports